import styled from 'styled-components'

import { EMAIL_STATUS } from './constants'

const getStatusColor = (status: TSFixMe): TSFixMe => {
  switch (status) {
    case EMAIL_STATUS.PROCESSED:
      return '#000000'
    case EMAIL_STATUS.DELIVERED:
    case EMAIL_STATUS.OPEN:
    case EMAIL_STATUS.CLICK:
      return '#66bb6a'
    case EMAIL_STATUS.DROPPED:
    case EMAIL_STATUS.DEFFERED:
    case EMAIL_STATUS.BOUNCE:
    case EMAIL_STATUS.BLOCKED:
    case EMAIL_STATUS.SPAM_REPORT:
    case EMAIL_STATUS.UNSUBSCRIBE:
      return '#f57c00'
  }

  return 'inherit'
}

const Container = styled.div<TSFixMe>`
  color: ${({ status }): TSFixMe => getStatusColor(status)};
  text-transform: capitalize;
`

export const EmailStatus = ({ status }: TSFixMe): TSFixMe => {
  return <Container status={status}>{status}</Container>
}
